import { collect } from "collect.js";
import { displayNotification, sendAPIRequest } from "helpers";

export const getCountries = async () => {
    try {
        const ret = await sendAPIRequest("/api/country/");
        const res = await ret.json();
        if (res.success) {
            return { success: true, data: res.data };
        } else {
            return { success: false, data: [] };
        }
    } catch (e) {
        console.log(e);
        return { success: false, data: [] };
    }
}

export const getLanguages = async () => {
    try {
        const ret = await sendAPIRequest("/api/list/master/3");
        const res = await ret.json();
        if (res.success) {
            return { success: true, data: res.data };
        } else {
            return { success: false, data: [] };
        }
    } catch (e) {
        console.log(e);
        return { success: false, data: [] };
    }
}

export const getCompetencyAreas = async () => {
    try {
        const ret = await sendAPIRequest(`/api/list/master/13?fields=id,list_element_name`);
        const res = await ret.json();
        if (res.success) {
            if (res.success) {
                let temp = [];
                res.data.forEach(val => {
                    if (val.id !== 58 && val.id !== 59) {
                        temp.push(val);
                    }
                });
                return { success: true, data: temp };
            } else {
                return { success: false, data: [] };
            }
        }
    } catch (e) {
        console.log(e);
        return { success: false, data: [] };
    }
}

export const getConcepts = async (countryId = '', languageId = '', competencyAreaId = '') => {
    try {
        const ret = await sendAPIRequest(`/api/qualitative-cleaning/get-specific-concepts/?country_id=${countryId}&language_id=${languageId}&competency_area_id=${competencyAreaId}`);
        const res = await ret.json();
        if (res.success) {
            if (res.success) {
                return { success: true, data: res.data };
            } else {
                return { success: false, data: [] };
            }
        }
    } catch (e) {
        console.log(e);
        return { success: false, data: [] };
    }
}

export const getRawText = async (id = '') => {
    try {
        const ret = await sendAPIRequest(`/api/qualitative-cleaning/get-raw-text/${id}`);
        const res = await ret.json();
        if (res.success && res.status === 200) {
            return { success: true, data: res.data };
        } else {
            return { success: false, data: [] };
        }
    } catch (e) {
        console.log(e);
        return { success: false, data: [] };
    }
}

export const getTags = async (id = '') => {
    try {
        const ret = await sendAPIRequest(`/api/qualitative-cleaning/get-tags/${id}`);
        const res = await ret.json();
        if (res.success && res.status === 200) {
            return { success: true, data: res.data };
        } else {
            return { success: false, data: [] };
        }
    } catch (e) {
        console.log(e);
        return { success: false, data: [] };
    }
}

export const deleteConcepts = async (ids = '', notification = true) => {
    try {
        const ret = await sendAPIRequest(`/api/qualitative-cleaning/delete-concepts/`, 'DELETE', {
            ids
        });
        const res = await ret.json();
        if (res.success && res.status === 200) {
            notification && displayNotification('success', 'Successfully deleted [B]');
            return { success: true, data: res.data };
        } else {
            notification && displayNotification('error', 'Failed to delete [B]');
            return { success: false, data: [] };
        }
    } catch (e) {
        console.log(e);
        notification && displayNotification('error', 'Failed to delete [F]');
        return { success: false, data: [] };
    }
}

export const editConcept = async (id = '', body = {}, notification = true) => {
    try {
        const ret = await sendAPIRequest(`/api/qualitative-cleaning/handle-concept-editing/${id}`, 'PUT', body);
        const res = await ret.json();
        if (res.success && res.status === 200) {
            notification && displayNotification('success', 'Successfully updated concept [B]');
            return { success: true, data: res.data };
        } else {
            notification && displayNotification('error', 'Failed to update concept [B]');
            return { success: false, data: [] };
        }
    } catch (e) {
        console.log(e);
        notification && displayNotification('error', 'Failed to update concept [F]');
        return { success: false, data: [] };
    }
}

export const mergeConcepts = async (ids = '', concept_name = '', notification = true) => {
    try {
        const ret = await sendAPIRequest(`/api/qualitative-cleaning/handle-concepts-merging/`, 'POST', {
            ids,
            concept_name
        });
        const res = await ret.json();
        if (res.success && res.status === 200) {
            notification && displayNotification('success', 'Successfully merged concepts [B]');
            return { success: true, data: res.data };
        } else {
            notification && displayNotification('error', 'Failed to merged concepts [B]');
            return { success: false, data: [] };
        }
    } catch (e) {
        console.log(e);
        notification && displayNotification('error', 'Failed to merged concepts [F]');
        return { success: false, data: [] };
    }
}

export const sortBy = (arr = [], key = '', orderBy = 'asc') => {
    const collection = orderBy === 'asc' ? collect(arr).sortBy(key) : collect(arr).sortByDesc(key);
    return collection.all();
}
